<template>
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div class="relative bg-primary-bg dark:bg-primary-dark-bg w-full max-w-md p-6 rounded-lg shadow-lg  m-5 sm:m-0">
            <button @click="$emit('close')"
                class="absolute top-3 right-4 text-gray-500 hover:text-black text-lg font-bold">
                <XMarkIcon class="w-6 h-6" />
            </button>
            <h2 class="text-lg font-bold text-gray-800 dark:text-light-text mb-4">Silme Onayı</h2>
            <p class="text-sm text-secondary-text dark:text-light-text  mb-6">
                <span v-if="message">{{ message }}</span>
                <span v-else>Bu kaydı silmek istediğinize emin misiniz?</span>
            </p>

            <div class="flex justify-end gap-3">
                <button @click="$emit('close')"
                    class="px-4 py-2 rounded bg-gray-100 dark:bg-gray-800 text-primary-text dark:text-gray-100 hover:bg-gray-200">
                    Vazgeç
                </button>
                <button @click="confirmDelete" class="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600">
                    Sil
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { XMarkIcon } from '@heroicons/vue/24/outline';

export default {
    name: 'DeleteModal',
    components: {
        XMarkIcon
    },
    props: {
        message: {
            type: String,
            default: ''
        },
        item: {
            type: Object,
            required: true
        }
    },
    methods: {
        confirmDelete() {
            this.$emit('confirm-delete', this.item);
        }
    }
};
</script>